module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Sports/football-56ef6054542d2e40cdc9732b389decb3.svg";